import { useHttpClient } from '@/common/api/httpClient';
import type { DashboardComponentType } from 'shared/dashboards/domain/dashboardComponentType';

//strukturen på svaret som skickas
export interface ToggleDashboardComponentTypeConfigRequest {
  dashboardComponentType: DashboardComponentType;
  enabled: boolean;
}

export function useToggleDashboardComponentTypeConfigApi() {
  return {
    execute,
  };

  async function execute(requestData: ToggleDashboardComponentTypeConfigRequest) {
    const httpClient = useHttpClient();
    const headers = httpClient.defaultHeaders();
    //skickar in ändringarna över vilka som ska vara aktiverade eller inte
    const request = new Request(httpClient.siteUrl('dashboardComponentTypeConfig/manage'), {
      method: 'POST',
      headers,
      body: JSON.stringify(requestData),
    });

    const response = await httpClient.execute(request);
    return response.ok;
  }
}
